import React from "react";
import "./plantelSelect.css";

export interface PlantelOpcion { id: number; name: string }

/**
 * Filtro "Plantel" de WappChat, CRM y WappTeam (Esteban, 2026-10-10: "no importa cuántos planteles tienen ni dónde están").
 * Por defecto "Todos mis planteles"; las opciones son solo los planteles de la persona (las manda el servidor).
 * Con uno solo no se enseña: no hay nada que elegir.
 */
const PlantelSelect: React.FC<{ opciones?: PlantelOpcion[] | null; value: number | null; onChange: (v: number | null) => void; className?: string }> = ({ opciones, value, onChange, className }) => {
	if (!opciones || opciones.length < 2) return null;
	return (
		<select className={"wl-sel plantel-sel" + (value ? " on" : "") + (className ? " " + className : "")} value={value ?? ""} aria-label="Plantel"
			onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}>
			<option value="">Todos mis planteles</option>
			{opciones.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
		</select>
	);
};

export default PlantelSelect;
